export default __webpack_public_path__ + "static/thumbnail-loadmill-b85e2b170e3164f2f42d2c2b52338832.png";